import {ValidationException} from '@practicegenius/http-clients-js/src/exceptions';
import {coreApiClientNoAuth} from '../../http/httpClientsJs';

export type LinkedPractice = {
  name: string;
  hubUrl: string;
};

function rethrowValidationErrors(
  transformErrors: (a: any) => any,
): (a: any) => void {
  return error => {
    if (error instanceof ValidationException) {
      throw new ValidationException(
        transformErrors(error.errors),
        error.response,
      );
    }

    throw error;
  };
}

/**
 * POST /global_users/registration/rewards_card_verification?include=practice
 */
export async function preverifyRewardsCard(cardNumber: string): Promise<{
  practice: LinkedPractice;
}> {
  const {
    // @ts-ignore
    data: {
      included: {practice},
    },
  } = await coreApiClientNoAuth._unsafe
    .post(
      '/global_users/registration/rewards_card_verification?include=practice',
      {card_number: cardNumber},
    )
    .catch(
      rethrowValidationErrors(({card_number}) => ({cardNumber: card_number})),
    );

  return {
    practice: {
      ...practice,
      name: practice.name,
      hubUrl: practice.hub_url,
    },
  };
}

type UsernameSuggestions = Array<string>;

export async function getUsernameSuggestions(
  count: number,
): Promise<UsernameSuggestions> {
  const {
    data: {items},
  } = await coreApiClientNoAuth._unsafe.get(
    `/global_users/username_suggestion?count=${count}`,
  );
  return items;
}
